import { PlaylistFeature } from '../graphql/globalTypes';
import { tourSupportsFeature, Tour } from './tourSupportsFeature';

export function tourSupportsUserPosition(tour: Tour): boolean {
  return tourSupportsFeature(tour, PlaylistFeature.USER_POSITION);
}
